import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { Wrapper } from "./makeExtraRepayments.styles";
import { MakeExtraRepaymentOptions } from "./makeExtraRepaymentOptions";
import { EXTRA_REPAYMENTS_ROUTE } from "../../route.constants";
import { PayBankTransfer } from "./payBankTransfer";
import { PayDebitCard } from "./payDebitCard";
import { PayDirectDebit } from "./payDirectDebit";

export const MakeExtraRepayments = ({accountId}) => {
  const { path } = useRouteMatch();

  return (
    <Wrapper>
      <MakeExtraRepaymentOptions exact path={path} />
      <Switch>
        <Route path={path + EXTRA_REPAYMENTS_ROUTE.DEBIT_CARD}>
          <PayDebitCard accountId={accountId}/>
        </Route>
        <Route path={path + EXTRA_REPAYMENTS_ROUTE.DIRECT_DEBIT}>
          <PayDirectDebit accountId={accountId}/>
        </Route>
        <Route path={path + EXTRA_REPAYMENTS_ROUTE.BANK_TRANSFER}>
          <PayBankTransfer accountId={accountId} />
        </Route>
      </Switch>
    </Wrapper>
  );
};
